import React from "react";
import TopImageSection from "../components/topImageSection";
import { useSelector } from "react-redux";
import { selectedServiceText } from "../../../constants/customer";
import SummaryStepCard from "../components/summaryStepCard";
import { Stepper } from "../components/stepper";
import { Outlet, useLocation } from "react-router-dom";
import { serviceSelectSteps, shopSelectSteps } from "../../../constants/placeOrderConst";

const PlaceOrder = () => {
  const { selectedService, orderFlow, selectedShop } = useSelector((state) => state.customer);
  const location = useLocation();

  // pick correct steps
  const steps = orderFlow === "shop" ? shopSelectSteps : serviceSelectSteps;

  // determine current step index
  const currentPath = location.pathname.split("/").pop();
  const currentIndex = steps.findIndex(step => step.route === currentPath);

  // prepare steps with status
  const stepsWithStatus = steps.map((step, index) => {
    if (index < currentIndex) return { ...step, status: "complete" };
    if (index === currentIndex) return { ...step, status: "active" };
    return { ...step, status: "upcoming" };
  });

  return (
    <div className="bg-white pb-4">
      <TopImageSection
        title={selectedService}
        text={selectedServiceText[selectedService]}
        page="pickup details"
      />
      <div className="my-3 md:my-6 w-full max-w-4xl mx-auto">
        <Stepper steps={stepsWithStatus} currentStep={currentIndex} />
      </div>
      <div className="flex flex-col w-full lgs:flex-row gap-4 md:gap-6 xlg:gap-8 py-3 md:py-8 px-2 sm:px-3 md:px-4 ld:px-6 xlg:px-12">
        <div className="w-full ">
          <Outlet />
        </div>
        <div className="hidden md:block">
          <SummaryStepCard />
        </div>
      </div>
    </div>
  );
};

export default PlaceOrder;
